import { Component, OnInit } from '@angular/core';
import { Route, Router } from '@angular/router';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  dropdown: boolean = true;
  searchbar: boolean = false;
  mobileView = false; // Initially assuming not in mobile view
  menu: string[] = ['Payment Gateway', 'PayG', 'E-Agreement', 'Web Integration', 'Payment Link', 'Create Payment', 'Pay Button', 'Payment QR', 'Invoice', 'G-Store', 'Transactions', 'Disputes', 'Refunds', 'Video KYC', 'Pay Profile', 'Easy Collect','Reseller'];
  value: string = 'Payment Gateway';
  storemanu: string = 'Payment Gateway';
  selectedValue: any;
  selectedMenu:any; 
constructor(private route:Router){

}
  ngOnInit(): void {
    const storeVal = localStorage.getItem('selectedValue');
    if (storeVal == 'english') {
      this.english = true;
      this.hindi = false;
    }
    if (storeVal == 'hindi') {

      this.english = false;
      this.hindi = true;
    }
    


  }
  menutype(event: any) {
    this.selectedMenu = event.target.value;
    this.showTable = false;
    if(this.selectedMenu== 'Payment Gateway')
    {
      this.route.navigate(['/']);
    }
    if(this.selectedMenu== 'PayG')
    {
      this.route.navigate(['/pay-g']);
    }
    if(this.selectedMenu== 'E-Agreement')
    {
      this.route.navigate(['/e-agrement']);
    }
    if(this.selectedMenu== 'Web Integration')
    {
      this.route.navigate(['/web-integration']);
    }
    if(this.selectedMenu== 'Payment Link')
    {
      this.route.navigate(['/payment-link']);
    }
    if(this.selectedMenu== 'Create Payment')
    {
      this.route.navigate(['/create-link']);
    }
    if(this.selectedMenu== 'Pay Button')
    {
      this.route.navigate(['/pay-button']);
    }
    if(this.selectedMenu== 'Payment QR')
    {
      this.route.navigate(['/payment-qr']);
    }
    if(this.selectedMenu== 'Invoice')
    {
      this.route.navigate(['/invoice']);
    }
    if(this.selectedMenu== 'G-Store')
    {
      this.route.navigate(['/g-store']);
    }
    if(this.selectedMenu== 'Transactions')
    {
      this.route.navigate(['/transaction']);
    }
    if(this.selectedMenu== 'Disputes')
    {
      this.route.navigate(['/disputes']);
    }
    if(this.selectedMenu== 'Video KYC')
    {
      this.route.navigate(['/video-kyc']);
    }
    if(this.selectedMenu== 'Refunds')
    {
      this.route.navigate(['/refunds']);
    }
    if(this.selectedMenu== 'Pay Profile')
    {
      this.route.navigate(['/pay-profile']);
    }
    if(this.selectedMenu== 'Easy Collect')
    {
      this.route.navigate(['/easy-collect']);
    }
    if(this.selectedMenu== 'Booking & Ticketing')
    {
      this.route.navigate(['/booking-tecketing']);
    }
    if(this.selectedMenu== 'Creating Profile')
    {
      this.route.navigate(['/create-profile ']);
    }
    if(this.selectedMenu== 'Reseller')
    {
      this.route.navigate(['/introduction-reseller']);
    }
  }

  search() {
    this.dropdown = false;
    this.searchbar = true;
  }
  drop() {
    this.dropdown = true;
    this.searchbar = false;
  }
  menues(event: string) {
    this.value = event;


  }

  showcolor: boolean | undefined;
  showcl: string = "";
  showpayment(show: boolean, val: string) {
    this.showcolor = show;
    this.showcl = val;
    if (this.showcolor == true && this.showcl == '1') {
      this.colors = "1";
    }
    if (this.showcolor == true && this.showcl == '2') {
      this.colors = "2";
    }
    if (this.showcolor == true && this.showcl == '3') {
      this.colors = "3";
    }
    if (this.showcolor == true && this.showcl == '4') {
      this.colors = "4";
    }
    if (this.showcolor == true && this.showcl == '5') {
      this.colors = "5";
    }




  }
  closemenu: boolean = false;
  child: string = '';
  subMenu(sub: string) {
    this.child = sub;
    if (this.child == '1') {

      this.up = false;
      this.down = true;

    }
    if (this.child == '2') {

      this.up1 = false;
      this.down1 = true;

    }
    if (this.child == '3') {

      this.up2 = false;
      this.down2 = true;

    }

  }
  up: boolean = true;
  down: boolean = false;
  up1: boolean = true;
  down1: boolean = false;
  up2: boolean = true;
  down2: boolean = false;
  close() {
    this.child = '';
    this.up = true;
    this.down = false;
    this.up1 = true;
    this.down1 = false;
    this.up2 = true;
    this.down2 = false;
  }


  colors: string = '1';
  color(cl: string) {
    var co = cl;
    this.colors = co;
  }


  onRotate(rotation: string) {
    const selectedCard = document.querySelector('.card') as HTMLElement;
    selectedCard.style.transform = rotation;
  }
  show: boolean = false;

  showContent() {
    this.show = true;
  }
  click() {
    this.showTable = false;
  }

  showTable: boolean = false;
  table() {
    this.showTable = true;
  }
  CloseTable() {
    this.showTable = false;
  }
  webFirst: boolean = true;
  webSecond: boolean = false;
  webVideos(web: string) {
    if (web == '1') {
      this.webFirst = true;
      this.webSecond = false;
    }
    if (web == '2') {
      this.webFirst = false;
      this.webSecond = true;
    }
  }
  lang: string = 'english';
  hindi: boolean = false;
  english: boolean = true;
language(event:Event){
  const target = event.target as HTMLLIElement;
  this.selectedValue = target.getAttribute('value');
  localStorage.setItem('selectedValue', this.selectedValue);
  location.reload();
}
  searchVal: string = 'Payment Gateway';
  getValue(val: string) {
    this.searchVal = val;
    if (this.searchVal === 'Payment Gateway' || this.searchVal === 'Payment' || this.searchVal === 'payment') {
     this.route.navigate(['/']);
    }
    if (this.searchVal === 'PayG' || this.searchVal === 'Pay G' || this.searchVal === 'payg' || this.searchVal === 'pay') {
      this.route.navigate(['/pay-g']);
    }
    if (this.searchVal === 'E-Agreement' || this.searchVal === 'agreement' || this.searchVal === 'e-agreement' || this.searchVal === 'Agreement') {
      this.route.navigate(['/e-agrement']);
    }
    if (this.searchVal === 'Web Integration' || this.searchVal === 'web integration' || this.searchVal === 'Integration' || this.searchVal === 'integration') {
      this.route.navigate(['/web-integration']);
    }
    if (this.searchVal === 'Payment Link' || this.searchVal === 'payment link' || this.searchVal === 'link') {
      this.route.navigate(['/payment-link']);
    }
    if (this.searchVal === 'Create Payment' || this.searchVal === 'create payment') {
      this.route.navigate(['/create-link']);
    }
    if (this.searchVal === 'G-Store' || this.searchVal === 'Store' || this.searchVal === 'g-store' || this.searchVal === 'store') {
      this.route.navigate(['/g-store']);
    }
    if (this.searchVal === 'Pay Button' || this.searchVal === 'pay button' || this.searchVal === 'button' || this.searchVal === 'Pay Buttons')  {
      this.route.navigate(['/pay-button']);
    }
    if (this.searchVal === 'Payment QR' || this.searchVal === 'payment qr' || this.searchVal === 'qr'|| this.searchVal === 'QR') {
      this.route.navigate(['/payment-qr']);
    }
    if (this.searchVal === 'Invoice' || this.searchVal === 'invoice') {
      this.route.navigate(['/invoice']);
    }
    if (this.searchVal === 'Video KYC' || this.searchVal === 'video' || this.searchVal === 'KYC' || this.searchVal === 'video kyc') {
      this.route.navigate(['/video-kyc']);
    }
    if (this.searchVal === 'Transactions' || this.searchVal === 'transactions') {
      this.route.navigate(['/transaction']);
    }
    if (this.searchVal === 'Refunds' || this.searchVal === 'refunds') {
      this.route.navigate(['/refunds']);
    }
    if (this.searchVal === 'Disputes' || this.searchVal === 'disputes') {
      this.route.navigate(['/disputes']);
    }

    if (this.searchVal === 'Pay Profile' || this.searchVal === 'pay profile' || this.searchVal === 'profile') {
      this.route.navigate(['/pay-profile']);
    }
    if (this.searchVal === 'Easy Collect' || this.searchVal === 'easy collect') {
      this.route.navigate(['/easy-collect']);
    }
    if (this.searchVal === 'smart collect' || this.searchVal === 'Smart Collect') {
      this.route.navigate(['/smart-collect']);
    }
    if (this.searchVal === 'Coupon' || this.searchVal === 'coupon' || this.searchVal === 'Coupons'|| this.searchVal === 'coupons') {
      this.route.navigate(['/coupons']);
    }
    if (this.searchVal ==='Booking & Ticketing' || this.searchVal === 'Booking' || this.searchVal === 'booking' || this.searchVal === 'ticketing' || this.searchVal === 'ticketing') {
      this.route.navigate(['/booking-tecketing']);
    }
    if (this.searchVal ==='Payg Features' || this.searchVal === 'Features' || this.searchVal === 'features' ) {
      this.route.navigate(['/features']);
    }
    if (this.searchVal ==='Merchant Dashboard' || this.searchVal === 'Merchant' || this.searchVal === 'Dashboard' || this.searchVal === 'merchant' || this.searchVal === 'dashboard' ) {
      this.route.navigate(['/merchnat-main']);
    }
    if (this.searchVal ==='Onboarding Process' || this.searchVal === 'Onboarding' || this.searchVal === 'onboarding' || this.searchVal === 'Process' ) {
      this.route.navigate(['/onboarding']);
    }
    if (this.searchVal ==='price' || this.searchVal === 'Price' || this.searchVal === 'price match' || this.searchVal === 'Price Match' ) {
      this.route.navigate(['/price']);
    }
    if (this.searchVal ==='Settlement' || this.searchVal === 'settlement' || this.searchVal === 'Settlement Split'  ) {
      this.route.navigate(['/settlement']);
    }
    if (this.searchVal ==='Reports' || this.searchVal === 'reports' || this.searchVal === 'report'  ) {
      this.route.navigate(['/reports']);
    }
    if (this.searchVal ==='reseller' || this.searchVal === 'Reseller'   ) {
      this.route.navigate(['/introduction-reseller']);
    }

  }

  
}
